import {
  AbstractControl,
  ValidatorFn,
  UntypedFormGroup,
  Validators
} from '@angular/forms';

export function ssnValidator(method: string): ValidatorFn {
  return (control: AbstractControl): { [key: string]: boolean } | null => {
    const value = control.value;
    if (method === 'Social Security Number') {
      if (
        control.value !== null &&
        control.value !== '' &&
        !control.value.match(/\d{9}$/)
      ) {
        return { ssnError: true };
      }
      if (value.length !== 9) {
        return { ssnError: true };
      }
      return null;
    }
    return null;
  };
}

export function locationRequiredForRole(): ValidatorFn {
  return (form: UntypedFormGroup): Validators | null => {
    const role = form.get('role').value;
    const location = form.get('location').value;

    if (role == '' && form.get('location')) {
      return null;
    }

    return role != 'NC_SHIP_SUPPORT' && (location == '' || location == null)
      ? { locationRequired: true }
      : null;
  };
}
